import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons'
import { Box, Card, Flex, Text, Tooltip } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { type CoreItem, type CoreInsurance } from '@flecto/types'
import {
  AvatarItem,
  DataTable,
  Icon,
  TextCurrency,
  type DataTableColumn,
} from '@flecto/ui/@shared'

export function ProductDetails({ insurance }: { insurance: CoreInsurance }) {
  const { t } = useTranslation('saas', { keyPrefix: 'insurances' })

  const columns: DataTableColumn<CoreInsurance>[] = [
    {
      accessor: 'product',
      width: 300,
      title: t('insurances_details.label_product_title'),
      render: (row) => (
        <Flex align='center' gap='sm'>
          <AvatarItem size='sm' item={insurance?.item as CoreItem} />
          <Text fw={500}>{row.item.title ?? '-'}</Text>
        </Flex>
      ),
    },
    {
      accessor: 'quantity',
      title: t('insurances_details.label_product_quantity'),
      render: (row) => <Text>{row.quantity ?? '-'}</Text>,
    },
    {
      accessor: 'rental_value',
      title: t('insurances_details.label_product_rental_value'),
      render: (row) => <TextCurrency cents={row.rental_cents ?? 0} />,
    },
    {
      accessor: 'incidence_value',
      title: (
        <Flex align='center' gap='xs'>
          <Text>{t('insurances_details.label_product_incidence_value')}</Text>
          <Tooltip label={t('insurances_details.tooltip_incidence_value')}>
            <Box mt={4}>
              <Icon icon={faQuestionCircle} color='dimmed' size='xs' />
            </Box>
          </Tooltip>
        </Flex>
      ),
      render: (row) => <TextCurrency cents={row.incidence_value_cents ?? 0} />,
    },
    {
      accessor: 'protect_fee',
      title: (
        <Flex align='center' gap='xs'>
          <Text>{t('insurances_details.label_product_protect_fee')}</Text>
          <Tooltip label={t('insurances_details.tooltip_protect_fee')}>
            <Box mt={4}>
              <Icon icon={faQuestionCircle} color='dimmed' size='xs' />
            </Box>
          </Tooltip>
        </Flex>
      ),

      render: (row) => <TextCurrency cents={row.price_cents ?? 0} />,
    },
  ]

  return (
    <Card>
      <Flex align='center' justify='space-between' mb='lg'>
        <Box style={{ flex: 1 }}>
          <Text fw={500}>{t('insurances_details.label_product')}</Text>
          <Text c='dimmed' size='sm'>
            {t('insurances_details.card_product_description')}
          </Text>
        </Box>
      </Flex>

      <DataTable
        withBorder={false}
        columns={columns}
        records={insurance ? [insurance] : []}
      />
    </Card>
  )
}
